<main>
    <!-- Banner -->
    <div class="breadcrumb__area breadcrumb__overlay breadcrumb__height p-relative fix"
      data-background="assets/img/breadcurmb/breadcurmb.jpg"
      style="background-image: url(assets/images/breadcurmb/pose_joy.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-xxl-12">
            <div class="breadcrumb__content z-index text-center">
              <h3 class="breadcrumb__title"> </h3>
              <div class="breadcrumb__list">
                <span><a class="no-underline" routerLink="/index">Home</a></span>
                <!-- <span class="dvdr"><i class="fa fa-angle-right"></i></span>
                <span>MOMents that matter</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Banner End -->

    <!-- Pose Event -->
      <div class="container py-5 mt-4">
        <div class="row justify-content-center mb-4">
            <!-- Selfie Capture Card -->
            <div class="col-md-6 col-lg-4">
              <div class="card h-100 text-center shadow-lg border-0" (click)="toggleSection('document')" style="cursor: pointer; transition: transform 0.2s;">
                <div class="card-body p-4">
                  <i class="fa fa-camera fa-3x text-primary mb-3"></i>
                  <h5 class="card-title fw-bold">Snap Your Joy</h5>
                  <p class="text-muted small">Click here to upload a Joyful photo!</p>
                </div>
              </div>
            </div>
        </div>

        <div *ngIf="openSection === 'document'" class="card p-4 shadow-lg border-0">
          <h5 class="mb-3 fw-bold text-center" style="color: #ED1D24;">📸 Capture Your Joyful Pose</h5>

          <div class="mb-3 text-center">
            <input type="file" (change)="uploadFromFolder($event)" class="form-control file_input" />
          </div>

          <button class="btn btn-success w-100" style="background: #ED1D24" (click)="uploadDocument()">
            🎉 Capture the Joy
          </button>

          <!-- <input type="file" (change)="uploadFromFolder($event)" class="form-control" />
          <button class="btn btn-secondary w-100 mt-3" (click)="uploadDocument()">Capture the Joy</button> -->
        </div>

      </div>
    <!-- Pose Event End -->

</main>
